module.exports = __webpack_public_path__ + "img/0fd53d0.jpg";